function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "VEXT");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "t",
  transform: "translate(-368.000000, -235.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "VEXT",
  transform: "translate(368.580000, 235.160000)"
}, React.createElement("polygon", {
  id: "V",
  fill: "#7BB3FF",
  points: "24.48 42.84 38.7 -4.26325641e-14 28.98 -4.26325641e-14 19.32 30.12 19.2 30.12 9.66 -4.26325641e-14 2.84217094e-14 -4.26325641e-14 13.86 42.84"
}), React.createElement("polygon", {
  id: "E",
  fill: "#EA3322",
  points: "73.68 42.84 73.68 34.92 50.58 34.92 50.58 24.42 71.34 24.42 71.34 17.1 50.58 17.1 50.58 7.92 73.2 7.92 73.2 -4.26325641e-14 41.16 -4.26325641e-14 41.16 42.84"
}), React.createElement("polygon", {
  id: "X",
  fill: "#F9DA77",
  points: "84.96 42.84 94.5 28.02 103.86 42.84 115.08 42.84 100.14 20.46 113.88 -4.26325641e-14 103.56 -4.26325641e-14 94.86 13.68 86.46 -4.26325641e-14 75.54 -4.26325641e-14 89.34 20.4 74.4 42.84"
}), React.createElement("polygon", {
  id: "T",
  fill: "#7BB3FF",
  points: "136.56 42.84 136.56 7.92 149.4 7.92 149.4 -4.26325641e-14 114.3 -4.26325641e-14 114.3 7.92 127.14 7.92 127.14 42.84"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "150px",
    height: "43px",
    viewBox: "0 0 150 43",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/logo.28a704a6.svg";
export { SvgComponent as ReactComponent };